module.exports = __webpack_public_path__ + "img/700x.681defcf.webp";